import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { colors, fontSizes, media } from '../styles';

const propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  size: PropTypes.string
};

const Subtitle = props => {
  const { children, className, size = 'small' } = props;

  return (
    <StyledSubtitle className={className} size={size}>
      {children}
    </StyledSubtitle>
  );
};

Subtitle.propTypes = propTypes;

const StyledSubtitle = styled.p`
  display: block;
  color: ${colors.midnightBlack};
  font-size: ${({ size }) => fontSizes.subtitle[size].fontSize};
  line-height: ${({ size }) => fontSizes.subtitle[size].lineHeight};
  font-weight: ${({ size }) => (size === 'small' ? '900' : 'normal')};
  margin: 0;
  
  p {
    font-size: ${({ size }) => fontSizes.subtitle[size].fontSize};
    line-height: ${({ size }) => fontSizes.subtitle[size].lineHeight};
    @media screen and (max-width: ${media.largeBottom}) {
      font-size: ${({ size }) => fontSizes.subtitle[size].mobile.fontSize};
      line-height: ${({ size }) => fontSizes.subtitle[size].mobile.lineHeight};
    }
  }

  @media screen and (max-width: ${media.mediumBottom}) {
    font-size: ${({ size }) => fontSizes.subtitle[size].mobile.fontSize};
    line-height: ${({ size }) => fontSizes.subtitle[size].mobile.lineHeight};
  }
`;

export { Subtitle };
